import AddressesTableItemDetails from './AddressesTableItemDetails'

export default AddressesTableItemDetails
